// extracted by mini-css-extract-plugin
module.exports = {"container":"recovery-success_container__1ZJUa","icon":"recovery-success_icon__2dEoA","title":"recovery-success_title__2zbIb","description":"recovery-success_description__23crq"};